import axiosPost from "../axiosPost";

export const usuarioLugarHorarioGet = async ({
  usuarioId = null,
  merchantServicioUsuarioId = null,
  gateUsuarioLugarHorarioId = null,
}, credentials) => {
  const body = {
    service: "GateUsuarioLugarHorarioGet",
    params: {
      merchantId: credentials.merchantId,
      usuarioId,
      merchantServicioUsuarioId,
      gateUsuarioLugarHorarioId
    },
  };

  return await axiosPost(body, credentials);
};